export default {"src":"/_next/static/media/uk-residency.294d35fa.svg","height":159,"width":215};